import { format, isValid } from 'date-fns';

import { Box, Icon, Text, TextButton } from '@zillow/constellation-10';
import { IconLockClosedFilled } from '@zillow/constellation-icons';

type Props = {
  listingAlias: string;
  isLoading?: boolean;
  isActiveProductTypeFree?: boolean;
  activeProductExpirationTimestamp?: string;
  onUnlockClick?: () => void;
};

const PremiumCTA = ({
  listingAlias,
  isLoading = false,
  isActiveProductTypeFree,
  activeProductExpirationTimestamp,
  onUnlockClick,
}: Props) => {
  const premiumAnalyticsPath = `/rental-manager/properties/${listingAlias}/premium-analytics`;

  const formattedExpirationDate =
    activeProductExpirationTimestamp && isValid(new Date(Number(activeProductExpirationTimestamp)))
      ? format(new Date(Number(activeProductExpirationTimestamp)), 'MMM\xa0d')
      : null;

  return (
    <Box
      css={{
        marginTop: { base: '400', lg: '600' },
        padding: '400',
        cursor: isActiveProductTypeFree ? 'pointer' : 'default',
        backgroundColor: 'bg.softest',
      }}
      onClick={isActiveProductTypeFree ? onUnlockClick : undefined}
    >
      {!isLoading && (
        <>
          {isActiveProductTypeFree ? (
            <Box css={{ display: 'flex', alignItems: 'center' }}>
              <Icon size="md" css={{ color: 'icon.subtle' }} render={<IconLockClosedFilled />} />
              <Text textStyle="body-sm" color="text.subtle" css={{ marginLeft: '200' }}>
                Unlock your custom data
              </Text>
            </Box>
          ) : (
            <Box css={{ display: 'flex', flexDirection: { base: 'column', xl: 'row' }, alignItems: 'center' }}>
              <TextButton textStyle="body-sm-bold" asChild>
                <a href={premiumAnalyticsPath}>Explore premium analytics</a>
              </TextButton>

              <Box css={{ marginRight: '400' }} />

              {formattedExpirationDate && (
                <Text textStyle="body-sm">
                  Premium benefits expire&nbsp;
                  <Text textStyle="body-sm-bold">{formattedExpirationDate}</Text>
                </Text>
              )}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default PremiumCTA;
